// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#new-arrival-message-list .list-card .card-body{padding:.5rem .75rem!important}#new-arrival-message-list .list-card .list-title{color:#333;font-weight:700;font-size:1rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
